import { render, staticRenderFns } from "./modal-warn.vue?vue&type=template&id=9dfd0158&scoped=true&"
import script from "./modal-warn.vue?vue&type=script&lang=js&"
export * from "./modal-warn.vue?vue&type=script&lang=js&"
import style0 from "./modal-warn.vue?vue&type=style&index=0&id=9dfd0158&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dfd0158",
  null
  
)

export default component.exports